import React from 'react';
import PropTypes from 'prop-types';

const Separator = ({
  className,
  content,
}) => (
  <div className={className}>{content}</div>
);

Separator.propTypes = {
  className: PropTypes.string,
  content: PropTypes.string,
};

export default Separator;
